import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

import { ComponentContentBanner } from '@ppg/core/models';
import { ImageComponent } from '@ppg/shared/components';
import { RichTextComponent } from '@ppg/shared/rich-text';

import { ContainerContentBannerCtaComponent } from '../../shared/components/container-content-banner-cta/container-content-banner-cta.component';
import { ContentBannerHeadlineComponent } from '../../shared/components/content-banner-headline/content-banner-headline.component';
import { ContentBannerSubheadingComponent } from '../../shared/components/content-banner-subheading/content-banner-subheading.component';

@Component({
  selector: 'ppg-horizontal-short-presentation-content-banner',
  standalone: true,
  imports: [
    CardModule,
    AnimateOnScrollModule,
    ButtonModule,
    RichTextComponent,
    ImageComponent,
    ContainerContentBannerCtaComponent,
    RichTextComponent,
    ContentBannerHeadlineComponent,
    ContentBannerSubheadingComponent,
    NgOptimizedImage,
  ],
  templateUrl: './horizontal-short-presentation.component.html',
  styleUrl: '../../container-content-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalShortPresentationContentBannerComponent {
  readonly horizontalShortComponentContentBanner = input.required<ComponentContentBanner>();
  readonly horizontalShortImagePositionRight = input.required<boolean>();
  readonly isResponsive = input(false);
  readonly logo = input.required<string>();

  public readonly horizontalShortPresentationContentBannerCta = computed(
    () => this.horizontalShortComponentContentBanner().content.cta,
  );
  readonly horizontalShortImgUrl = computed(
    () => this.horizontalShortComponentContentBanner().content.image?.url ?? '',
  );
  readonly horizontalShortImgHeight = computed(
    () => this.horizontalShortComponentContentBanner().content.image?.height ?? 0,
  );
  readonly horizontalShortImgWidth = computed(
    () => this.horizontalShortComponentContentBanner().content.image?.width ?? 0,
  );
  readonly horizontalShortImgDescription = computed(
    () => this.horizontalShortComponentContentBanner().content.image?.description ?? '',
  );
  readonly horizontalShortHeadline = computed(
    () => this.horizontalShortComponentContentBanner().content.headline ?? '',
  );
  readonly horizontalShortSubheading = computed(
    () => this.horizontalShortComponentContentBanner().content.subheading ?? '',
  );
  readonly horizontalShortContent = computed(() => this.horizontalShortComponentContentBanner().content.content ?? []);

  readonly showLogo = computed(() => this.horizontalShortComponentContentBanner().content.showLogo);
}
